import { PROCESS_STEPS } from "../data/content";
import { useReveal } from "../hooks/useReveal";

export default function Process() {
  const ref = useReveal();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 lg:py-40 bg-white"
    >
      <div ref={ref} className="reveal max-w-[90rem] mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <p className="overline mb-6 flex items-center gap-3">
              Design Process
            </p>
            <h2
              data-testid="process-headline"
              className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-stone-900"
            >
              Eight quiet stages,
              <em className="italic text-[#4A6076]"> one lasting result</em>.
            </h2>
          </div>
          <p className="max-w-md text-stone-600 leading-relaxed">
            Our method is a slow choreography of research, sketching, sampling
            and installation. No stage is skipped — every one earns its place.
          </p>
        </div>

        {/* Horizontal scroll timeline */}
        <div
          data-testid="process-timeline"
          className="overflow-x-auto pb-6 -mx-6 md:-mx-12 px-6 md:px-12"
        >
          <div className="flex items-stretch gap-8 min-w-max">
            {PROCESS_STEPS.map((step, i) => (
              <div
                key={step.title}
                data-testid={`process-step-${i}`}
                className="w-[280px] lg:w-[320px] shrink-0 relative"
              >
                <div className="flex items-center gap-4 mb-6">
                  <span className="w-12 h-12 border border-stone-300 rounded-full flex items-center justify-center font-serif-display text-stone-900 text-lg">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {i < PROCESS_STEPS.length - 1 && (
                    <div className="flex-1 timeline-line" />
                  )}
                </div>
                <h3 className="font-serif-display text-2xl text-stone-900">
                  {step.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-stone-600">
                  {step.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
